import { SpanTracker } from "./util.js";
export class SumoLogicLogSubscriber {
    logger;
    tracker = new SpanTracker();
    constructor(opts) {
        this.logger = opts.logger;
    }
    onEvent = (event) => {
        this.logger.log({
            level: event.level,
            time: new Date(event.timestamp).toISOString(),
            message: event.message,
            ...event.fields,
        });
    };
    onEnter = (span) => this.tracker.enter(span, { start: performance.now() });
    onExit = (span) => {
        const entry = this.tracker.exit(span);
        if (!entry)
            return;
        const duration = performance.now() - entry.start;
        this.logger.log({
            level: span.level,
            time: new Date(span.timestamp).toISOString(),
            message: `${span.name} completed in ${duration.toFixed(2)}ms`,
            duration: duration.toFixed(2),
            ...span.fields,
        });
    };
}
export class SumoLogicRUMBrowserSubscriber {
    rum;
    tracker = new SpanTracker();
    constructor(opts) {
        this.rum = opts.rum;
    }
    onEvent = (e) => {
        const ctx = { ...e.fields, level: e.level };
        if (e.error) {
            const errorMessage = e.error instanceof Error ? e.error.message : String(e.error);
            return this.rum?.recordError(errorMessage, ctx);
        }
    };
    onEnter = (s) => {
        if (!this.rum?.tracer)
            return s;
        const span = this.rum.tracer.startSpan(s.name, s.fields);
        extractFlatten(s.fields, (key, value) => span.setAttribute(key, value));
        this.tracker.enter(s, span);
        return s;
    };
    onExit = (s) => {
        if (!this.rum?.tracer)
            return;
        this.tracker.exit(s)?.end();
    };
}
const extractFlatten = (data, handler) => {
    for (const key in data) {
        extractFlattenInner(handler, key, data[key]);
    }
};
const extractFlattenInner = (handler, key, value) => {
    if (value === null || value === undefined)
        return;
    else if (typeof value === "number")
        handler(key, value);
    else if (typeof value === "string")
        handler(key, value);
    else if (typeof value === "boolean")
        handler(key, value);
    else if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
            extractFlattenInner(handler, `${key}[${i}]`, value[i]);
        }
    }
    else if (typeof value === "object" && value !== null) {
        for (const nextKey in value) {
            extractFlattenInner(handler, `${key}.${nextKey}`, value[nextKey]);
        }
    }
};
//# sourceMappingURL=sumologic.js.map